(function($) {
	"use strict";
	
	function init() {
		$('.events-filter').on('submit', submitForm);
	}

	function submitForm(e) {
		let form = e.currentTarget;
		let $selects = $('select', form);
		
		e.preventDefault();

		// don't show empty values in URL params...
		$selects.each((i, el) => {
			if (!el.value.length) {
				el.disabled = true;
			}
		});

		form.submit();

		// ... but still allow to resubmit if they clicked the wrong cat before page reloads
		$selects.prop('disabled', false);
	}
	
	$(init);
	
})(jQuery);